import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-grow" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<header class=\"w-full sm:max-w-4xl mx-auto flex flex-col items-stretch gap-20 px-6 py-10\"><div><div class=\"profile-image mx-auto\"></div></div><div class=\"flex flex-col flex-grow font-mono text-4xl font-black sm:ml-10 mt-5 sm:mt-0 gap-5\"><div class=\"self-start\">passionated</div><div class=\"self-center\">web</div><div class=\"self-end\">developer</div></div></header>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}